import { z } from "zod";

export const MeetingStatusEnum = z.enum(["scheduled", "completed", "cancelled_meeting"]);

export const MeetingSchema = z.object({
  id: z.string().uuid(),
  jurisdictionId: z.string().uuid(),
  sourceId: z.string().uuid().optional().nullable(),
  bodyName: z.string().min(1),
  startsAt: z.string().datetime(),
  location: z.string().optional().nullable(),
  status: MeetingStatusEnum,
  externalId: z.string().optional().nullable(),
  sourceUrl: z.string().url().optional().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export type Meeting = z.infer<typeof MeetingSchema>;
